import axios from "axios";
import API from "../helpers/api";

let user = JSON.parse(localStorage.getItem("currentUser"));

export const searchsettingsMgmt = (searchItem,pgno) => {
    let url = `${API.SearchSettings}?ShipId=${searchItem.shipId}&ShipName=${searchItem.shipName}&toMail=${searchItem.toMail}&ccMail=${searchItem.ccMail}&PageNumber=${pgno}&PageSize=${searchItem.PageSize}`;
    return dispatch => {
        axios.get(url)
            .then((response) => {
                dispatch({
                    type: "getSearchSettingsSuccess",
                    data: response.data,
                })
            })
            .catch((error) => {
                dispatch({
                    type: "getSearchSettingsFailure",
                    error: "ERROR"
                })
            })
    }
}
  
export const getSettingsDetail = (settingId) => {
    let url = `${API.GetShippingSettings}?shipid=${settingId}`;
    return dispatch => {
        axios.get(url)
            .then((response) => {
                dispatch({
                    type: "getSettingDetailsSuccess",
                    data: response.data,
                })
            })
            .catch((error) => {
                dispatch({
                    type: "getSettingDetailsFailure",
                    error: "ERROR"
                })
            })
    }
}







